import { Component } from '@angular/core';

@Component({
  selector: 'sis-error',
  templateUrl: './error.page.html',
  styleUrls: ['./error.page.scss'],
  standalone: false,
})
export class ErrorPage {}
